export const validatePassword = (value: string): boolean => {
    const minLength = value.length >= 6;
    const hasLatin = /[a-zA-Z]/.test(value);
    const hasDigit = /\d/.test(value);

    return minLength && hasLatin && hasDigit;
};